import { getUserFields } from "components/user/config";
import { fetchEmployee } from "directus/src/operations";

export async function getUserById(id) {
  try {
    const query = {
      fields: [
        ...getUserFields(),
        getUserFields("reports_to"),
        "department.id",
        "email",
        "consumption_factor",
        "function.id",
        "phone_no",
        "emoji",
        "x",
        "linkedin",
        "website",
        "employee_id",
        "job_title",
        "allocable",
        "joining_date",
        "user.id",
      ],
    };

    const response = await fetchEmployee(id, query);

    return {
      ...response,
      department: response.department?.id,
      grade: response.grade?.id,
      role: response.user?.role?.id,
      status: response.user?.status,
      user: response.user,
      function: response.function?.id,
    };
  } catch (error) {
    console.log(error);
    throw error;
  }
}
